import { useFavoriteAssetsElements } from 'store/settings/hooks'
import { styled } from '@mui/material/styles'
import { useAccountAssetList } from '../AccountModal/hooks'
import { useIsLogin } from 'store/account/hooks'
import { useNavigate } from 'react-router-dom'
import { MaskedAssets } from 'components/MaskedAssets'
import { Stack } from '@mui/material'

const PinIndexWrap = styled(Stack)`
  flex-direction: row;
  align-items: center;
  border-radius: 4px;
  gap: 8px;
  overflow: hidden;

  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`

const StyledTitle = styled('span')`
  color: rgba(149, 164, 173, 1);
  white-space: nowrap;
  font-size: 12px;
  line-height: 18px;
  transition: all 0.2s ease-in-out;
`

const StyledValue = styled('b')`
  font-weight: 600;
  color: rgba(229, 234, 238, 1);
  white-space: nowrap;
  font-size: 14px;
  line-height: 20px;
`

const StyledItem = styled(Stack)`
  flex: 1;
  justify-content: center;
  height: 48px;
  font-size: 12px;
  text-align: left;
  padding: 0 8px;
  border-radius: 4px;

  transition: all 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: rgba(46, 54, 59, 1);
  }
`

const AccountPinIndex = () => {
  const favoriteAssetsElements = useFavoriteAssetsElements()
  const { memoAssetsList } = useAccountAssetList()
  const isLogin = useIsLogin()
  const navigate = useNavigate()

  if (!isLogin) return null

  if (favoriteAssetsElements.length === 0) return null

  return (
    <PinIndexWrap>
      {/* @ts-ignore */}
      {memoAssetsList.map((item, i) => {
        if (favoriteAssetsElements.indexOf(item.type) > -1) {
          return (
            <StyledItem
              key={i}
              onClick={() => {
                navigate(item.to)
              }}
            >
              <StyledTitle>{item.title}</StyledTitle>
              <StyledValue>
                <MaskedAssets>
                  {item?.render ? item?.render() : item?.value}
                </MaskedAssets>
              </StyledValue>
            </StyledItem>
          )
        }
      })}
    </PinIndexWrap>
  )
}

export default AccountPinIndex
